import React from "react";
import { useRouter } from "next/router";
import IconView from "@/shared/components/IconView/IconView";

import styles from "./tile.module.scss";

const Tile = ({ imageUrl, image, title, linkAs, count, newTab = false}) => {
  const router = useRouter();

  const handleClick = (e) => {
    if (!newTab) {
      e.preventDefault();

      router.push(linkAs);
    }
  };

  return (
    // eslint-disable-next-line react/jsx-no-target-blank
    <a
      target={newTab ? "_blank" : "_self"}
      rel={newTab ? "noreferrer" : ""}
      className={styles["tile-list-item"]}
      href={linkAs}
      onClick={handleClick}
    >
      {
        imageUrl
          ? <img alt={title} src={imageUrl} className={styles["tile-list-item__img"]}/>
          : <IconView icon={image}  className={styles["tile-list-item__icon"]}/>
      }
      <div className={styles["wrapper-text"]}>
        <span className={styles["tile-list-item__count"]}>{count}</span>
        <span
          className={styles["tile-list-item__title"]}
          dangerouslySetInnerHTML={{ __html: title }}
        />
      </div>
    </a>
  );
};

export default Tile;
